var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "core-data-statistics" },
    [
      _c(
        "div",
        { staticClass: "filter-card" },
        [
          _c(
            "div",
            { staticClass: "time-tabs" },
            _vm._l(_vm.rangeOptions, function (item) {
              return _c(
                "div",
                {
                  key: item.value,
                  staticClass: "time-tab",
                  class: { active: _vm.queryParams.timeRange === item.value },
                  on: {
                    click: function ($event) {
                      return _vm.onTimeRangeChange(item.value)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "range-btn",
              class: { active: _vm.queryParams.timeRange === 6 },
              on: {
                click: function ($event) {
                  return _vm.onTimeRangeChange(6)
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-date" }),
              _vm._v(" "),
              _c("span", [_vm._v("自定义时间范围")]),
            ]
          ),
          _vm._v(" "),
          _vm.queryParams.timeRange === 6
            ? _c("el-date-picker", {
                staticClass: "range-picker",
                attrs: {
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  "value-format": "yyyy-MM-dd",
                },
                on: { change: _vm.onDateRangeChange },
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-select",
              attrs: { placeholder: "选择渠道", clearable: "" },
              model: {
                value: _vm.queryParams.unionCode,
                callback: function ($$v) {
                  _vm.$set(_vm.queryParams, "unionCode", $$v)
                },
                expression: "queryParams.unionCode",
              },
            },
            _vm._l(_vm.unionOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.isSysAdmin
            ? _c(
                "el-select",
                {
                  staticClass: "filter-select",
                  attrs: {
                    placeholder: "选择租户",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.queryParams.appId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "appId", $$v)
                    },
                    expression: "queryParams.appId",
                  },
                },
                _vm._l(_vm.appOptions, function (item) {
                  return _c("el-option", {
                    key: item.appId,
                    attrs: { label: item.name, value: item.appId },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onQuery } },
            [_vm._v("确认")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { staticClass: "filter-reset", on: { click: _vm.onReset } },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stat-cards" },
        _vm._l(_vm.statCards, function (card) {
          return _c("div", { key: card.label, staticClass: "stat-card" }, [
            _c("div", { staticClass: "stat-label" }, [
              _vm._v(_vm._s(card.label)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(card.value)),
            ]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-card" },
        [
          _c("div", { staticClass: "table-head" }, [
            _c("div", { staticClass: "title" }, [_vm._v("核心数据统计")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "export-btn",
                on: { click: _vm.openExportDialog },
              },
              [
                _c("span", [_vm._v("导出")]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "export-icon",
                    attrs: { viewBox: "0 0 24 24", "aria-hidden": "true" },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10.5 4H6a2.5 2.5 0 0 0-2.5 2.5v11A2.5 2.5 0 0 0 6 20h11a2.5 2.5 0 0 0 2.5-2.5V13",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M13 11 20 4m0 0h-5m5 0v5" } }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
              },
            },
            [
              _vm.isSysAdmin
                ? _c("el-table-column", {
                    attrs: { label: "所属租户", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(_vm.fmt(scope.row.appName)))]
                          },
                        },
                      ],
                      null,
                      false,
                      2804343653
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "bizDate", label: "日期", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "渠道", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.fmt(scope.row.unionName)))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "新增会员数", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.fmt(scope.row.memberCount)))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总订单数", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.fmt(scope.row.orderCountTotal))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "有效订单数",
                  align: "center",
                  "class-name": "cell-emphasis",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.fmt(scope.row.orderCount)))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总订单金额(元)", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.fmt(scope.row.orderAmountTotal))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "有效订单金额(元)",
                  align: "center",
                  "class-name": "cell-emphasis",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.fmt(scope.row.orderAmount)))]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "总订单佣金(元)", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.fmt(scope.row.orderIncomeTotal))),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "有效订单佣金(元)",
                  align: "center",
                  "class-name": "cell-emphasis",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.fmt(scope.row.orderIncome)))]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                staticClass: "gmv-pagination",
                attrs: {
                  "current-page": _vm.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.size,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "数据导出管理",
            visible: _vm.exportDialogVisible,
            width: "700px",
            "custom-class": "gmv-dialog",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialogVisible = $event
            },
            close: _vm.onExportDialogClose,
          },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.onExportTabClick },
              model: {
                value: _vm.activeExportTab,
                callback: function ($$v) {
                  _vm.activeExportTab = $$v
                },
                expression: "activeExportTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "数据导出", name: "export" } },
                [
                  _c(
                    "div",
                    { staticClass: "export-tab-content" },
                    [
                      _c("div", { staticClass: "export-tip" }, [
                        _c("i", { staticClass: "el-icon-warning" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "系统限制：24 小时内，数据导出次数限制在 5 次内。"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "exportForm",
                          attrs: {
                            model: _vm.exportForm,
                            rules: _vm.exportRules,
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "文件名称：", prop: "fileName" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "export-name",
                                attrs: { placeholder: "请输入文件名称" },
                                model: {
                                  value: _vm.exportForm.fileName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.exportForm, "fileName", $$v)
                                  },
                                  expression: "exportForm.fileName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "导出格式：", prop: "fileType" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.exportForm.fileType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.exportForm, "fileType", $$v)
                                    },
                                    expression: "exportForm.fileType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("xlsx格式"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("csv格式"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "导出记录", name: "record" } },
                [
                  _c(
                    "div",
                    { staticClass: "record-tab-content" },
                    [
                      _c(
                        "div",
                        { staticClass: "record-filter" },
                        [
                          _c("el-input", {
                            staticClass: "record-name",
                            attrs: {
                              placeholder: "输入文件名查询",
                              clearable: "",
                            },
                            model: {
                              value: _vm.recordQueryParams.fileName,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordQueryParams, "fileName", $$v)
                              },
                              expression: "recordQueryParams.fileName",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "record-status",
                              attrs: { placeholder: "全部状态", clearable: "" },
                              model: {
                                value: _vm.recordQueryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.recordQueryParams, "status", $$v)
                                },
                                expression: "recordQueryParams.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "处理中", value: 0 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "已完成", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "失败", value: 2 },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onQueryRecord },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            { on: { click: _vm.onResetRecord } },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.recordLoading,
                              expression: "recordLoading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.recordTableData,
                            border: "",
                            "header-cell-style": { "text-align": "center" },
                            "cell-style": { "text-align": "center" },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "fileName",
                              label: "文件名",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "处理进度", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.status === 0
                                      ? _c(
                                          "span",
                                          { staticClass: "status-processing" },
                                          [_vm._v("处理中")]
                                        )
                                      : scope.row.status === 1
                                      ? _c(
                                          "span",
                                          { staticClass: "status-done" },
                                          [_vm._v("已完成")]
                                        )
                                      : scope.row.status === 2
                                      ? _c(
                                          "span",
                                          { staticClass: "status-fail" },
                                          [_vm._v("失败")]
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fileSizeText",
                              label: "文件大小",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "处理结束时间", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(_vm.fmt(scope.row.finishTime))
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.status === 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "download-link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDownloadRecord(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "download-icon",
                                                attrs: {
                                                  viewBox: "0 0 24 24",
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M12 3v10m0 0 4-4m-4 4-4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("下载")]),
                                          ]
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pagination-wrap" },
                        [
                          _c("el-pagination", {
                            staticClass: "gmv-pagination",
                            attrs: {
                              "current-page": _vm.recordQueryParams.page,
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.recordQueryParams.size,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.recordTotal,
                            },
                            on: {
                              "size-change": _vm.handleRecordSizeChange,
                              "current-change": _vm.handleRecordCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeExportTab === "export"
            ? _c(
                "div",
                { staticClass: "dialog-footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.exportDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onConfirmExport },
                    },
                    [_vm._v("确认导出")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }